module.exports = __webpack_public_path__ + "img/3.a34e3e49.png";